import { BenchFoulTypes, CoachFoulTypes } from "../subTypes/EliteFoulTypes";

export const FoulTypeSelect = {
  name: "foul-type-select",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "foul.type",
  showOn: [{ state: "primary", value: "foul-type-select", operator: "is" }],
  startEvent: false,
  startPlay: false,
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showDetails: { events: ["main"] },
  allowBack: { state: "primary", value: "foul-player-select", event: "main" },
  children: [
    {
      name: "foul-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [
        {
          state: "event.bench",
          value: false,
          operator: "is",
          event: "main",
        },
        {
          state: "event.coach",
          value: false,
          operator: "is",
          event: "main",
        },
      ],
      startEvent: false,
      startPlay: false,
      options: {
        value: "subType",
        children: ["personal", "offensive", "technical", "unsportsmanlike"],
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "copyEvent", value: "foul", type: "to" },
          ],
          conditions: [
            {
              item: "subType",
              value: "offensive",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            {
              action: "saveData",
              value: "turnover",
              type: "eventType",
            },
            {
              action: "saveData",
              value: "offensive",
              type: "subType",
            },
            {
              action: "clearData",
              value: ["x", "y", "options"],
              type: "main",
            },
            { action: "sendEvent", value: "new", type: "main" },
            {
              action: "setPossession",
              value: { currentEntity: false },
              type: "main",
            },
            { action: "copyEvent", value: "foul", type: "from" },
          ],
          conditions: [
            {
              item: "subType",
              value: "offensive",
              event: "main",
              operator: "is",
            },
            {
              item: "hasPossession",
              value: true,
              event: "main",
              operator: "is",
            },
          ],
          operator: "all",
        },
        {
          actions: [{ action: "nextState", value: "foul-drawn-player-select", type: "primary" }],
          conditions: [
            {
              item: "subType",
              value: "offensive",
              event: "foul",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "copyEvent", value: "foul", type: "to" },
            { action: "nextState", value: "foul-drawn-player-select", type: "primary" },
          ],
          conditions: [
            {
              item: "subType",
              value: "offensive",
              event: "main",
              operator: "not",
            },
          ],
        },
      ],
    },
    {
      name: "bench-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [
        {
          state: "event.bench",
          value: true,
          operator: "is",
          event: "main",
        },
      ],
      startEvent: false,
      startPlay: false,
      options: {
        value: "subType",
        children: BenchFoulTypes,
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            {
              action: "clearData",
              value: ["personId"],
              type: "main",
            },
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "copyEvent", value: "foul", type: "to" },
          ],
          conditions: [],
        },
        {
          actions: [{ action: "nextState", value: "free-throw-awarded", type: "primary" }],
          conditions: [
            {
              item: "subType",
              value: "benchTechnical",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "clearData", value: ["subType"], type: "main" },
            {
              action: "nextState",
              value: "cancellation-foul-type-select",
              type: "primary",
            },
          ],
          conditions: [
            {
              item: "subType",
              value: "cancellation",
              event: "main",
              operator: "is",
            },
          ],
        },
      ],
    },
    {
      name: "coach-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [
        {
          state: "event.coach",
          value: true,
          operator: "is",
          event: "main",
        },
      ],
      startEvent: false,
      startPlay: false,
      options: {
        value: "subType",
        children: CoachFoulTypes,
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            {
              action: "clearData",
              value: ["personId"],
              type: "main",
            },
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "copyEvent", value: "foul", type: "to" },
          ],
          conditions: [],
        },
        {
          actions: [{ action: "nextState", value: "foul-drawn-player-select", type: "primary" }],
          conditions: [
            {
              item: "subType",
              value: ["coachTechnical", "cancellation"],
              event: "main",
              operator: "not",
            },
          ],
        },
        {
          actions: [{ action: "nextState", value: "free-throw-awarded", type: "primary" }],
          conditions: [
            {
              item: "subType",
              value: "coachTechnical",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "clearData", value: ["subType"], type: "main" },
            {
              action: "nextState",
              value: "cancellation-foul-type-select",
              type: "primary",
            },
          ],
          conditions: [
            {
              item: "subType",
              value: "cancellation",
              event: "main",
              operator: "is",
            },
          ],
        },
      ],
    },
  ],
};
